<template>
  <span class="search">
    <a-input
      class="search_input"
      placeholder="搜索文件"
      size="large"
      v-model:value="keywords"
      @pressEnter="search"
      :allowClear="true"
    >
      <template #suffix><div @click="search" class="search_img" /></template> </a-input
  ></span>
</template>

<script>
import { ref } from 'vue';
import { message } from 'ant-design-vue';

export default {
  props: {
    isSearchFile: Boolean,
    rlogkey: String,
  },
  setup(props, context) {
    const keywords = ref(''); // 搜索的关键词
    function search() {
      window._rlog.push(['_trackEvent', props.rlogkey]);
      if (!keywords.value) {
        message.error({ content: '请输入搜索内容' });
        return;
      }
      context.emit('searchFile', { query: keywords.value }, true);
    }
    function cancelSearch() {
      keywords.value = '';
      // context.emit('searchFile', {}, false);
    }

    return {
      cancelSearch,
      search,
      keywords,
    };
  },
};
</script>

<style lang="scss" scoped>
.search {
  position: absolute;
  right: 0;
  top: 0;
}
.search_input {
  padding: 0 0 0 16px;
  box-sizing: border-box;
  width: 260px;
  height: 40px;
  float: right;
  background: #f5f6f8;
  border-radius: 8px;
  border-color: $grey4;
  .search_img {
    cursor: pointer;
    width: 32px;
    height: 32px;
    margin: 0 4px 0 6px;
    @include background('./imgs/search_icon.png');
  }
  ::v-deep(svg) {
    display: none;
  }
  ::v-deep(.ant-input-clear-icon) {
    background: url('./imgs/clear_input.png') center center no-repeat;
    background-size: 100% 100%;
    width: 24px;
    height: 24px;
    margin: 0;
  }
  ::v-deep(.ant-input.ant-input-lg) {
    background-color: $grey4;
  }
}
::v-deep(.ant-input-affix-wrapper-focused) {
  @include input-focus;
  .search_img {
    @include background('./imgs/search_icon_focus.png');
  }
}
.search_input {
  ::v-deep(.ant-input.ant-input-lg:focus) {
    background-color: #fff;
  }
}
</style>
